import React from "react";
import { Modal, Button } from "antd";
import { DeleteOutlined, CloseOutlined } from "@ant-design/icons";

export type DeleteRapModalProps = {
  open: boolean;
  rapName?: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DeleteRapModal: React.FC<DeleteRapModalProps> = ({
  open,
  rapName,
  loading = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={520}
      destroyOnClose
      className="delete-mart-modal modal-round"
      closeIcon={<CloseOutlined className="delete-mart-close-icon" />}
    >
      <div className="delete-mart-hero">
        <div className="delete-mart-hero-icon">
          <DeleteOutlined />
        </div>
        <div className="delete-mart-hero-wave" />
      </div>

      <div className="delete-mart-content">
        <div className="delete-mart-title">Delete Rap</div>
        <div className="delete-mart-subtitle">
          Are you sure you want to delete this rap{rapName ? ` (${rapName})` : ""}?
          <br />
          This action cannot be undone.
        </div>

        <Button
          type="primary"
          danger
          size="large"
          className="delete-mart-btn"
          onClick={onConfirm}
          loading={loading}
          disabled={loading}
        >
          Delete
        </Button>
      </div>
    </Modal>
  );
};

export default DeleteRapModal;
